export const exportToCSV = (data: any[], filename: string) => {
  if (data.length === 0) return;

  const headers = Object.keys(data[0]);
  const csvContent = [
    headers.join(','),
    ...data.map((row) =>
      headers.map((header) => {
        const value = row[header];
        if (value === null || value === undefined) return '';
        if (typeof value === 'object') return JSON.stringify(value);
        return String(value).replace(/"/g, '""');
      }).join(',')
    ),
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const exportToPDF = async (content: string, filename: string) => {
  // Simple PDF export using browser print
  const printWindow = window.open('', '_blank');
  if (!printWindow) {
    alert('Please allow popups to export PDF');
    return;
  }

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>${filename}</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 20px; }
          h1 { color: #333; }
          pre { white-space: pre-wrap; }
        </style>
      </head>
      <body>
        ${content}
      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.print();
};

export const exportAnalysisToPDF = (analysis: any, title: string) => {
  const content = `
    <h1>${title}</h1>
    <h2>Summary</h2>
    <p>${analysis.summary || 'N/A'}</p>
    ${analysis.risksAndOpportunities ? `
      <h2>Risks and Opportunities</h2>
      <h3>Risks</h3>
      <ul>
        ${analysis.risksAndOpportunities.risks?.map((r: string) => `<li>${r}</li>`).join('') || ''}
      </ul>
      <h3>Opportunities</h3>
      <ul>
        ${analysis.risksAndOpportunities.opportunities?.map((o: string) => `<li>${o}</li>`).join('') || ''}
      </ul>
    ` : ''}
    ${analysis.keyMetrics ? `
      <h2>Key Metrics</h2>
      <ul>
        ${Object.entries(analysis.keyMetrics).map(([k, v]) => `<li><strong>${k}:</strong> ${v}</li>`).join('')}
      </ul>
    ` : ''}
  `;

  exportToPDF(content, title);
};

